import { toast } from "react-toastify";
import { errorIcon, infoIcon, successIcon, warningIcon } from "../../../assets";

interface EventEHRCustomToastMessageProps {
  title: string;
  subTitle?: string;
  status: "success" | "error" | "warning" | "info";
}

const getToastConfig = (status: "success" | "error" | "warning" | "info") => {
  const config = {
    success: {
      backgroundColor: "white",
      borderColor: "#9DC0EE",
      textColor: "#155724",
      icon: <img src={successIcon} alt="" />,
      toastMethod: toast.success,
    },
    error: {
      backgroundColor: "#FFF5F3",
      borderColor: "#F4B0A1",
      textColor: "#721c24",
      icon: <img src={errorIcon} alt="" />,
      toastMethod: toast.error,
    },
    warning: {
      backgroundColor: "#FFF8EC",
      borderColor: "#F7D9A4",
      textColor: "#856404",
      icon: <img src={warningIcon} alt="" />,
      toastMethod: toast.warning,
    },
    info: {
      backgroundColor: "#F5F9FF",
      borderColor: "#9DC0EE",
      textColor: "#0c5460",
      icon: <img src={infoIcon} alt="" />,
      toastMethod: toast.info,
    },
  };

  return config[status];
};

export const eventEHRCustomToastMessage = ({
  title = "Toast Title",
  subTitle = "",
  status = "success",
}: EventEHRCustomToastMessageProps) => {
  const { backgroundColor, borderColor, textColor, icon, toastMethod } =
    getToastConfig(status);

  toastMethod(
    <div
      style={{ display: "flex", alignItems: "center", borderRadius: "20px" }}
    >
      <div
        style={{
          marginRight: "12px",
        }}
      >
        {icon}
      </div>
      <div>
        <div className="font-bold	font-size-14px color-27303A">{title}</div>
        {subTitle && (
          <p
            className="font-normal font-size-12px color-2F3F53 mt-4"
            style={{ margin: 0 }}
          >
            {subTitle}
          </p>
        )}
      </div>
    </div>,
    {
      icon: false, // Disable default icon
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      style: {
        backgroundColor: backgroundColor,
        color: textColor,
        border: `1px solid ${borderColor}`,
        borderRadius: "12px",
      },
    }
  );
};
